import { requestManagerActions } from "../../constants/actionTypes";
import { vmInSuccessStatus } from "../../constants/componentConstants";

const INITIAL_STATE = {
  requestList: [],
  trackRequests: [],
  approveDeclineFlag: false,
  deploymentList: [],
  deploymentJobs: {},
  listError: "",
  request: [],
  requestLabList: [],
  requestTicket: "",
  reqApproveDeclineMsg: "",
  deleteRequestLab: "",
  notifyAgainData: "",
  notifyAgainMessage: "",
  exportRequestData: {
    data: {},
    loading: false,
  },
  BulkRequestData: {
    data: {},
    loading: false,
  },
};

const requestManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case requestManagerActions.REQUESTS_LIST_REQUEST:
      return {
        ...state,
        requestList: {},
      };
    case requestManagerActions.REQUESTS_LIST_SUCCESS:
      return {
        ...state,
        requestList: {
          ...action?.payload?.data,
        },
        listError: "",
      };
    case requestManagerActions.SUCCESS_REQUEST_LAB:
      return {
        ...state,
        requestLabList: action?.payload?.data,
        listError: "",
      };
    case requestManagerActions.SUCCESS_REQUEST_TICKET:
      return {
        ...state,
        requestTicket: action?.payload?.data,
        listError: "",
      };
    case requestManagerActions.SUCCESS_APPROVE_DECLINE_REQUEST:
      return {
        ...state,
        reqApproveDeclineMsg: action?.payload?.data,
        listError: "",
      };
    case requestManagerActions.SUCCESS_DELETE_REQUEST_TICKET:
      return {
        ...state,
        deleteRequestLab: action?.payload?.data,
        listError: "",
      };
    case requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_SUCCESS:
      return {
        ...state,
        notifyAgainData: action?.payload?.data,
      };
    case requestManagerActions.SUCCESS_NOTIFY_AGAIN:
      return {
        ...state,
        notifyAgainMessage: action?.payload,
      };
    case requestManagerActions.REQUESTS_LIST_ERROR:
    case requestManagerActions.DEPLOYMENT_LIST_ERROR:
    case requestManagerActions.ERROR_DEPLOYMENT_JOBS:
    case requestManagerActions.ERROR_REQUEST:
    case requestManagerActions.ERROR_REQUEST_LAB:
    case requestManagerActions.ERROR_REQUEST_TICKET:
    case requestManagerActions.ERROR_APPROVE_DECLINE_REQUEST:
    case requestManagerActions.ERROR_DELETE_REQUEST_TICKET:
    case requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_ERROR:
    case requestManagerActions.ERROR_NOTIFY_AGAIN:
      return {
        ...state,
        listError: action?.payload,
      };
    case requestManagerActions.REQUESTS_LIST_CLEAR:
      return {
        ...state,
        requestList: {},
        deploymentList: {},
      };
    case requestManagerActions.DEPLOYMENT_LIST_REQUEST:
      return {
        ...state,
      };
    case requestManagerActions.DEPLOYMENT_LIST_SUCCESS:
      return {
        ...state,
        deploymentList: {
          ...action?.payload?.data,
        },
        listError: "",
      };
    case requestManagerActions.SUCCESS_DEPLOYMENT_JOBS:
      return {
        ...state,
        deploymentJobs: { ...action?.payload?.data },
        listError: "",
      };
    case requestManagerActions.REMOVE_DEPLOYMENT_JOBS:
      return {
        ...state,
        deploymentJobs: {},
      };
    case requestManagerActions.SUCCESS_REQUEST:
      return {
        ...state,
        request: action?.payload?.data,
        listError: "",
      };
    case requestManagerActions.SUCCESS_TRACK_REQUEST:
      return {
        ...state,
        trackRequests: action?.payload?.data,
      };
    case requestManagerActions.APPROVE_DECLINE_REQUEST:
      return {
        ...state,
        approveDeclineFlag: false,
      };
    case requestManagerActions.APPROVE_DECLINE_SUCCESS:
      return {
        ...state,
        approveDeclineFlag: true,
        requestList: {},
      };
    case requestManagerActions.SET_DEPLOYMENT_DATA:
      let tempDeploymentJob = state.deploymentJobs;

      if (action?.payload?.payload?.stage) {
        if (Array.isArray(state?.deploymentJobs?.deployment_stage)) {
          // Condition to check successful stage
          if (
            vmInSuccessStatus.includes(action?.payload?.payload?.stage?.state)
          ) {
            let completedStages = [];

            state?.deploymentJobs?.deployment_stage.forEach((stageObj) => {
              // Select only success stages
              if (vmInSuccessStatus?.includes?.(stageObj?.state)) {
                completedStages.push(stageObj);
              }
            });
            tempDeploymentJob.deployment_stage = [
              ...completedStages,
              action?.payload?.payload?.stage,
            ];
          } else {
            tempDeploymentJob.deployment_stage = [
              ...tempDeploymentJob?.deployment_stage,
              action?.payload?.payload?.stage,
            ];
          }
        } else {
          console.log(
            "state?.deploymentJobs?.deployment_stage is not an array"
          );
        }
      }
      return {
        ...state,
        deploymentJobs: tempDeploymentJob,
      };

    // Export Request
    case requestManagerActions.EXPORT_REQUEST_ACTION:
      return {
        ...state,
        exportRequestData: {
          ...state?.exportRequestData,
          loading: true,
        },
      };

    case requestManagerActions.EXPORT_REQUEST_SUCCESS:
      return {
        ...state,
        exportRequestData: {
          ...state?.exportRequestData,
          loading: false,
          data: action?.payload,
        },
      };

    case requestManagerActions.EXPORT_REQUEST_ERROR:
      return {
        ...state,
        exportRequestData: {
          ...state?.exportRequestData,
          loading: false,
        },
      };

    case requestManagerActions.EXPORT_REQUEST_RESET:
      return {
        ...state,
        exportRequestData: {
          ...state?.exportRequestData,
          data: {},
        },
      };

    // Bulk Update Request
    case requestManagerActions.BULK_UPDATE_REQUEST_ACTION:
      return {
        ...state,
        BulkRequestData: {
          ...state?.BulkRequestData,
          loading: true,
        },
      };

    case requestManagerActions.BULK_UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        BulkRequestData: {
          ...state?.BulkRequestData,
          loading: false,
          data: action?.payload,
        },
      };

    case requestManagerActions.BULK_UPDATE_REQUEST_ERROR:
      return {
        ...state,
        BulkRequestData: {
          ...state?.BulkRequestData,
          loading: false,
        },
      };

    case requestManagerActions.BULK_UPDATE_REQUEST_RESET:
      return {
        ...state,
        BulkRequestData: {
          ...state?.BulkRequestData,
          data: {},
        },
      };

    default:
      return state;
  }
};

export default requestManager;
